import { requestGet, requestPost, requestPut, requestDelete } from '../request'
import apiPath from './apiPath'

const api = {
  CreateMenuGroupSchedule(payload) {
    return requestPost(apiPath.MEMU_GROUP_SCHEDULE.path, payload)
  },

  GetOneMenuGroupSchedule(menuGroupScheduleID) {
    return requestGet(
      `${apiPath.MEMU_GROUP_SCHEDULE.path}/${menuGroupScheduleID}`
    )
  },

  GetAllMenuGroupSchedule(paging, sorting, filtering) {
    return requestGet(apiPath.MEMU_GROUP_SCHEDULES.path, {
      page: paging.page,
      size: paging.size,
      sortBy: sorting.byField,
      sortDir: sorting.isDesc ? 'asc' : 'desc',
      f_outletCode: filtering.outletCode,
      f_menuGroupCode: filtering.menuGroupCode,
      f_status: filtering.status,
      f_beginDate: filtering.beginDate,
      f_endDate: filtering.endDate,
      f_beginDay: filtering.beginDay,
      f_endDay: filtering.endDay,
      f_beginHour: filtering.beginHour,
      f_endHour: filtering.endHour
    })
  },

  UpdateMenuGroupSchedule(menuGroupScheduleID, payload) {
    return requestPut(
      `${apiPath.MEMU_GROUP_SCHEDULE.path}/${menuGroupScheduleID}`,
      payload
    )
  },

  DeleteMenuGroupSchedule(menuGroupScheduleID) {
    return requestDelete(
      `${apiPath.MEMU_GROUP_SCHEDULE.path}/${menuGroupScheduleID}`
    )
  }
}

export default api
